import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'
import clsx from 'clsx'
import {
    BlobStorageBaseUrl,
    KnowledgepointSubPath,
} from 'components/Constants/blobStorage'
import { ListingLevel } from 'components/Models/product'
import GridItem from 'components/Surfaces/GridItem'
import { pxToRem } from 'components/Utilities/unitUtils'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    logoImage: {
        height: 25,
        objectFit: 'contain',
        display: 'block',
    },
    AGDLogoOne: {
        marginTop: -5,
        marginBottom: theme.spacing(0.75),
        width: 125,
        height: 22,
        fontSize: pxToRem(11),
        fontWeight: 700,
    },
}))
interface ProductListingCardLogoProps {
    listingLevel: ListingLevel
    loading?: boolean
    blobStorageBaseURL?: string
}
export const ProductListingCardLogo: React.FC<ProductListingCardLogoProps> = ({
    listingLevel,
    loading,
    blobStorageBaseURL = BlobStorageBaseUrl,
}) => {
    const classes = useStyles()
    return (
        <GridItem className="logoMainContainer">
            {loading && (
                <Skeleton
                    variant="rect"
                    animation="pulse"
                    className="loadingSkeleton"
                />
            )}
            {!loading &&
                (listingLevel === ListingLevel.PremiumMasterSpec ||
                listingLevel === ListingLevel.Manufacturer ? (
                    <img
                        height={25}
                        className={classes.logoImage}
                        alt="Masterspec Logo"
                        src={`${blobStorageBaseURL}/${KnowledgepointSubPath}/masterspec_simplified.png`}
                    />
                ) : (
                    <Typography
                        className={clsx(classes.AGDLogoOne, 'noStatus')}
                    />
                ))}
        </GridItem>
    )
}
